export default __webpack_public_path__ + "static/meaning-b59ad4342a0bff74885022ed61736ae3.png";